import { faUserSlash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type React from 'react'
import PageWrapper from '../../../../../components/Pagewrapper'

/**
 * Replaces the onboarding checklist once onboarding is refused on compliance grounds — including the pre-KYC
 * country gate blanket-reject (a country of residence the Country Risk Register does not support, ADR-0015).
 * A rejected customer must not be left with an actionable "Start KYC" step. The specific, MLRO-owned reason is
 * carried by the app-shell compliance banner (AppNavigator); this panel is the neutral non-actionable state
 * that sits under it, so the phrasing is deliberately kept generic (and not duplicated from the banner).
 */
const ComplianceRejected: React.FC = () => (
  <PageWrapper fixedWidth>
    <div className="card gap-2 mt-20 flex flex-col text-center items-center">
      <FontAwesomeIcon
        icon={faUserSlash}
        className="h-9 w-9 mt-5 text-brand-light-red"
      />
      <h1 className="font-semi text-lg">We can't continue your application</h1>
      <span className="text-description w-2/3 mb-5 mt-5">
        We're not able to proceed with your onboarding at this time. If you have
        any questions, our support team is happy to help.
      </span>
      <div className="h-[1px] bg-black/5 w-full" />
      <div className="flex flex-col items-center p-5">
        <p className="font-medium mb-2">Need help?</p>
        <span className="text-description">
          Write us on{' '}
          <a
            href="mailto:support@penning.io"
            className="hover:underline text-brand-blue"
          >
            support@penning.io
          </a>
          .
        </span>
      </div>
    </div>
  </PageWrapper>
)

export default ComplianceRejected
